import { render, staticRenderFns } from "./DashBusinessGamification.vue?vue&type=template&id=4f862b6a&scoped=true&"
import script from "./DashBusinessGamification.vue?vue&type=script&lang=js&"
export * from "./DashBusinessGamification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f862b6a",
  null
  
)

export default component.exports